export default "__VITE_ASSET__CBfDH48U__"